import React, { FC, useCallback, useEffect } from 'react';

import { ActionButtons } from 'src/apps/mobile-common/components/action-buttons/ActionButtons';
import { useMobileSdkIssueDetailsQuery } from 'src/apps/mobile-sdk/hooks/useMobileSdkIssueDetailsQuery';
import { MobileComponentDetailsBlock } from 'src/common/components/mobile-component-details-block/MobileComponentDetailsBlock';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { getBaseURL } from 'src/common/helpers/UrlNormalizingHelper';

interface IMobileSdkComponentDetailsBlockProps {
	issueId: string;
	testId: string;
	scanName: string;
	runTime: string;
	issueNumber: string;
	isFullPageMode?: boolean;
	setError?: (error: unknown) => void;
}

export const MobileSdkComponentDetailsBlock: FC<IMobileSdkComponentDetailsBlockProps> = ({
	issueId,
	testId,
	scanName,
	runTime,
	issueNumber,
	isFullPageMode,
	setError
}) => {
	const issueDetailsQuery = useMobileSdkIssueDetailsQuery(issueId, testId);

	useEffect(() => {
		if (issueDetailsQuery.isError) {
			setError?.(issueDetailsQuery.error);
		}
	}, [issueDetailsQuery.isError, issueDetailsQuery.error, setError]);

	const issuePageUrl = RoutesHelper.getMobileSdkIssueInfoPath({ testId, issueId });
	const urlToCopy = `${getBaseURL()}${issuePageUrl}`;

	const openIssueInNewTab = useCallback((): void => {
		window.open(issuePageUrl, '_blank');
	}, [issuePageUrl]);

	const actionButtons = !isFullPageMode ? (
		<ActionButtons textToCopy={urlToCopy} openNewTab={openIssueInNewTab} />
	) : null;

	return (
		<MobileComponentDetailsBlock
			isLoading={issueDetailsQuery.isLoading}
			issue={issueDetailsQuery.data}
			scanName={scanName}
			runTime={runTime}
			issueNumber={issueNumber}
			actionButtons={actionButtons}
			isFullPageMode={isFullPageMode}
		/>
	);
};
